// extracted by mini-css-extract-plugin
module.exports = {"container":"quiz-results_container__2I4NY","modal":"quiz-results_modal__2Dk-b","containerModal":"quiz-results_containerModal__3ukBh"};